module.exports = __webpack_public_path__ + "static/img/team.0a16957.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/team.png
// module id = SxN4
// module chunks = 12